import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import api from './api';

// Caches GET /Customers/Me (contains the customer logos as base64, ~400 kB)
// in localStorage per customer, same 6-hour TTL as the customer config cache.
// Invalidate via invalidateCustomerMeCache() whenever customer data is updated.

const CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours

function cacheKey() {
  const token = Cookies.get('accessToken');
  if (!token) return null;
  return jwtDecode(token).CustomerId + '-CustomerMe';
}

export async function loadCustomerMeCached() {
  const key = cacheKey();
  if (!key) return null;

  const stored = localStorage.getItem(key);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (parsed.expiry && Date.now() <= parsed.expiry) {
        return parsed.data;
      }
    } catch (e) {
      // corrupt entry — fall through to refetch
    }
    localStorage.removeItem(key);
  }

  const response = await api.get('/Customers/Me');
  const customer = response.data.value || null;
  try {
    localStorage.setItem(key, JSON.stringify({ data: customer, expiry: Date.now() + CACHE_TTL }));
  } catch (e) {
    // localStorage full — serve uncached
  }
  return customer;
}

export function invalidateCustomerMeCache() {
  const key = cacheKey();
  if (key) localStorage.removeItem(key);
}

// Human-friendly ERP name for UI labels ("Sent á DK") — collapses connector variants
// (e.g. DKWithProjectPhases) to the product name the user knows.
export function getErpDisplayName(erpName) {
  if (!erpName) return 'ERP';
  if (erpName.startsWith('DK')) return 'DK';
  if (erpName.startsWith('BusinessCentral')) return 'Business Central';
  if (erpName === 'ReglaIs') return 'Regla';
  return erpName;
}
